"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validateEmailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
/**
 * Tests the email for valid format according to the RFC 5322 standard
 * @param email
 */
function isValidEmail(email) {
    return validateEmailRegex.test(email);
}
exports.isValidEmail = isValidEmail;
;
//# sourceMappingURL=email-utilities.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/utilities/email-utilities.js
// module id = 1155
// module chunks = 0